import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'

/* Router Modules */
Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/fwpt/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/login/register'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/index'], resolve),
        name: '首页',
        meta: { title: '首页', icon: 'dashboard', noCache: true, affix: true }
      },
      // {
      //   path: 'hcContractEdit',
      //   hidden: true,
      //   component: () => import('@/views/hc/contract/edit.vue'),
      //   name: 'hcContractEdit',
      //   meta: { title: '合同信息编辑', icon: 'dashboard', noCache: true }
      // },
      // {
      //   path: 'hcContractChangeEdit',
      //   hidden: true,
      //   component: () => import('@/views/hc/contract-change/edit.vue'),
      //   name: 'hcContractChangeEdit',
      //   meta: { title: '合同变更编辑', icon: 'dashboard', noCache: true }
      // },
      // {
      //   path: 'hcCustomerEdit',
      //   hidden: true,
      //   component: () => import('@/views/hc/customer/edit.vue'),
      //   name: 'hcCustomerEdit',
      //   meta: { title: '客户信息编辑', icon: 'dashboard', noCache: true }
      // },
      // {
      //   path: 'hcCustomerChangeEdit',
      //   hidden: true,
      //   component: () => import('@/views/hc/customer-change/edit.vue'),
      //   name: 'hcCustomerChangeEdit',
      //   meta: { title: '客户变更编辑', icon: 'dashboard', noCache: true }
      // },
      // {
      //   path: 'hcFlowEdit',
      //   hidden: true,
      //   component: () => import('@/views/hc/flow/edit.vue'),
      //   name: 'hcFlowEdit',
      //   meta: { title: '流程单编辑', icon: 'dashboard', noCache: true }
      // },
      // {
      //   path: 'hcPaymentSlipEdit',
      //   hidden: true,
      //   component: () => import('@/views/hc/payment-slip/edit.vue'),
      //   name: 'hcPaymentSlipEdit',
      //   meta: { title: '缴费单编辑', icon: 'dashboard', noCache: true }
      // },
      // {
      //   path: 'hcReturnedMoneyEdit',
      //   hidden: true,
      //   component: () => import('@/views/hc/returned-money/edit.vue'),
      //   name: 'hcReturnedMoneyEdit',
      //   meta: { title: '回款信息维护编辑', icon: 'dashboard', noCache: true }
      // },
      {
        path: '/flow/myPending',
        hidden: true,
        component: () => import('@/views/flow/myPendingIndex.vue'),
        name: 'MyPendingIndex',
        meta: { title: '我的待办', icon: 'dashboard', noCache: true }
      },{
        path: 'contractApplyEdit',
        hidden: true,
        component: () => import('@/views/crm/contract/apply/edit.vue'),
        name: 'contractApplyEdit',
        meta: { title: '合同申请编辑', icon: 'dashboard', noCache: true }
      },
      {
        path: 'complaintEdit',
        hidden: true,
        component: () => import('@/views/crm/aftersale/complaint/edit.vue'),
        name: 'complaintEdit',
        meta: { title: '客诉单据编辑', icon: 'dashboard', noCache: true }
      }
    ]
  },
  {
    path: '/fast/report',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'reportReview/:reportCode',
        component: (resolve) => require(['@/views/fast/report/reportReview'], resolve),
        name: 'fastReportReportReview',
        //meta: { title: '报表预览' }
      }, {
        path: 'reportDevReview/:reportCode',
        component: (resolve) => require(['@/views/fast/report/reportDevReview'], resolve),
        name: 'fastReportReportReview:reportCode',
        //meta: { title: '报表预览' }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/fwpt/profile/index'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/gen',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'edit/:tableId(\\d+)',
        component: (resolve) => require(['@/views/systempt/gen/editTable'], resolve),
        name: 'GenEdit',
        meta: { title: '修改生成配置' }
      }
    ]
  }

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: '/error',
    component: Layout,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    meta: {
      title: 'Error Pages',
      icon: '404'
    },
    children: [
      {
        path: '401',
        component: () => import('@/views/error-page/401'),
        name: 'Page401',
        meta: { title: '401', noCache: true }
      },
      {
        path: '404',
        component: () => import('@/views/error-page/404'),
        name: 'Page404',
        meta: { title: '404', noCache: true }
      }
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach((to, from, next) => {
  if(to.path.indexOf("/fast/report/reportReview/")>=0){
    const menuReprotTitle = window.localStorage.getItem('menuReprotTitle');
    var allData = {};
    if (menuReprotTitle == null || menuReprotTitle.length === 0) {

    }else{
      allData = JSON.parse(menuReprotTitle);
    }

    to.meta.title = allData[to.params.reportCode];
    if(to.meta.title==null ){
      to.meta.title = '报表预览';
    }
  }

  next()
})

export default router
